import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import useStateWithPromise from '../../utils/useEffectUpdate';

const FabUI = (props) => {
    const [instanceM, setInstanceM] = useState();
    const [close, setClose] = useStateWithPromise(false);

    useEffect(() => {
        var fab = document.querySelectorAll('.fixed-action-btn');
        const instance = M.FloatingActionButton.init(fab, {
            hoverEnabled: false
        });
        setInstanceM(instance);

        document.addEventListener("mouseup", function (event) {
            mouseup(event);
        });

        return () => {
            document.removeEventListener("mouseup", function (event) {
                mouseup(event);
            });
        }
        // eslint-disable-next-line
    }, []);

    const mouseup = (event) => {
        var obj = document.getElementById("fabUI-id");
        if (!close && obj && !obj.contains(event.target)) {
            setClose(true);
        }
    }

    useEffect(() => {
        if (close && instanceM) {
            instanceM[0].close();
            setClose(false)
        }
        // eslint-disable-next-line
    }, [close]);

    return (
        <div id='fabUI-id' className="fixed-action-btn">
            <div className="btn-floating fab btn-large" >
                <i className="mdi mdi-dots-vertical" ></i>
            </div>
            <ul>
                {props.buttons?.map((item, index) => (
                    <li key={index}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            width: '300px',
                            marginLeft: '-250px'
                        }}
                        >
                            {item.label &&
                                <b onClick={item.onClick} style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    backgroundColor: 'white',
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                    padding: '2px 25px 2px 15px',
                                    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
                                    borderRadius: '30px 0 0 30px',
                                    cursor: 'pointer',
                                    color: item.color ?? ''
                                }}
                                >
                                    {item.label}
                                </b>
                            }
                            <div onClick={() => {
                                item.onClick(); instanceM[0].close();
                            }} style={{ marginLeft: '-20px', backgroundColor: item.color }} className="btn-floating fab">{item.icon} || <i className="mdi mdi-check-circle" /></div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default FabUI;
